import { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Trans } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { ToolBar } from '../../app/components/ToolBar';
import { ToolBarSearch } from '../../app/components/ToolBarSearch';
import {findShops} from '../entries/actions';
import {selectShops} from '../entries/entriesSlice';

interface ActionsProps {
  onSearch: Function;
};
const Actions = (props: ActionsProps) => (
  <>
    <ToolBarSearch placeholder="shops.search" onChange={props.onSearch} />
  </>
);

export function Overview() {
  const shops = useAppSelector(selectShops);
  const dispatch = useAppDispatch();
  const [localShops, setLocalShops] = useState<EntryShop[]>([]);

  useEffect(() => {
    dispatch(findShops());
  }, [dispatch]);

  // Filter local shops
  const filterShops = useCallback((value:string) => {
    if (!shops) { return; }
    if (value && value.length < 2) {
      return setLocalShops(shops);
    }
    setLocalShops(shops.filter((item) => item.name.toLowerCase().includes(value)));
  }, [shops]);

  // Copy shops for local use
  useEffect(() => {
    if (!shops) { return; }
    setLocalShops(shops);
  }, [shops]);

  return (<>
    <ToolBar title='register.title' actions={<Actions onSearch={filterShops}/>} />
    <div className='o-table'>
      <table>
        <thead>
          <tr>
            <td><Trans i18nKey="name" /></td>
          </tr>
        </thead>
        <tbody>
          {localShops.map(c =>
            <tr className='o-table-row' key={c.id}>
              <td><Link to={`/entries/shop/${c.id}`}>{c.name}</Link></td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </>
  )
}
